import { render, staticRenderFns } from "./AppointmentEmployeeNotification.vue?vue&type=template&id=54428163&"
import script from "./AppointmentEmployeeNotification.vue?vue&type=script&lang=js&"
export * from "./AppointmentEmployeeNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54428163')) {
      api.createRecord('54428163', component.options)
    } else {
      api.reload('54428163', component.options)
    }
    module.hot.accept("./AppointmentEmployeeNotification.vue?vue&type=template&id=54428163&", function () {
      api.rerender('54428163', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/notification/types/AppointmentEmployeeNotification.vue"
export default component.exports